import React from "react";
import { Provider } from "react-redux";
import jwt_decode from "jwt-decode";
import store from "./store";
import setAuthToken from "./utils/setAuthToken";
import { logoutUser, setCurrentUser } from "./actions/authActions";
import { fetchUserFeatures } from "./actions/featureAccessActions";
import { getImpersonatorSession, exitImpersonation } from "./utils/impersonation";
import { SET_IMPERSONATION_ACTIVE } from "./actions/types";
import Routes from "./routes/Routes";
import "./assets/scss/global.scss";
//import { tz } from "moment";
import publicRoutes from "./routes/types/public";
import { matchPath } from "react-router-dom";
import { captureAttribution } from "./utils/attribution";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import {
  PUSHER_APP_KEY,
  PUSHER_APP_CLUSTER,
  LARAVEL_ECHO_WS_HOST,
  LARAVEL_ECHO_WS_PORT,
  LARAVEL_ECHO_WSS_PORT,
} from "./utils/prefixes";

const publicRouteList = [];
publicRoutes.forEach((route, index) => {
  publicRouteList.push(route.path);
});

let isPublicRoute = false;

publicRouteList.forEach((path, index) => {
  const matches = matchPath(path, window.location.pathname);
  if (matches) {
    isPublicRoute = true;
    return;
  }
});

const isBookingHostPreviewRoute = [
  "/booking/:business_id/:slug",
  "/booking/:slug/:dated/:slot",
  "/adhoc-booking/:slug/:dated?/:slot?",
].some((path) => matchPath(path, window.location.pathname));

// Check for token

if (!isPublicRoute || isBookingHostPreviewRoute) {
  if (localStorage.jwtToken) {
    // Set auth token header auth
    setAuthToken(localStorage.jwtToken);
    // Decode token and get user info and exp
    const decoded = jwt_decode(localStorage.jwtToken);
    // Set user and isAuthenticated

    if (localStorage.config) {
      const config = JSON.parse(localStorage.config);
      store.dispatch(setCurrentUser(config.user));
      store.dispatch(fetchUserFeatures());
    }

    // Re-initialize banner flag when page is refreshed during an active impersonation
    if (getImpersonatorSession()) {
      store.dispatch({ type: SET_IMPERSONATION_ACTIVE, payload: true });
    }

    // Check for expired token
    const currentTime = Date.now() / 1000;
    //tz.setDefault(localStorage.userTimezone);
    if (decoded.exp < currentTime && !isBookingHostPreviewRoute) {
      if (getImpersonatorSession()) {
        // Token expired mid-impersonation — restore the super-admin session instead
        // of wiping it with logoutUser()
        exitImpersonation(store.dispatch, null);
        window.location.href = "/super-admin/subscriber";
      } else {
        // Normal expiry — log out fully
        store.dispatch(logoutUser());
        window.location.href = "/admin/login";
      }
    }
  }
}








// Capture visitor attribution params on every hard page load (fire-and-forget).
// Runs once when the module is first loaded — before the component tree mounts.
captureAttribution();

// Setup Laravel echo and pusher
if (!window.Echo) {
  window.Pusher = Pusher;
  window.Echo = new Echo({
    broadcaster: "pusher",
    key: PUSHER_APP_KEY,
    cluster: PUSHER_APP_CLUSTER,
    wsHost: LARAVEL_ECHO_WS_HOST,
    wsPort: LARAVEL_ECHO_WS_PORT,
    wssPort: LARAVEL_ECHO_WSS_PORT,
    encrypted: false, // laravel websocket we need to make it false
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    forceTLS: true,
  });
}

const App = () => {
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
};

export default App;
